!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"));else if ("function" == typeof define && define.amd) define(["react"], t);else {
    var n = "object" == typeof exports ? t(require("react")) : t(e.React);

    for (var o in n) {
      ("object" == typeof exports ? exports : e)[o] = n[o];
    }
  }
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(1),
        r = (n.n(o), function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }());

    var c = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return window.EMS ? window.EMS.plugins = {
          name: "react",
          version: "1.0.1"
        } : console.warn("使用该插件前请先引入EMS的核心库,详细配置查看http://ems.58corp.com/doc/chapter-2/install.html"), n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, o["Component"]), r(t, [{
        key: "componentDidCatch",
        value: function value(e, t) {
          var n = {};
          n.componentName = this.formatComponentName(t.componentStack), window.EMS && window.EMS.captureException(e, n);
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.children;
        }
      }, {
        key: "formatComponentName",
        value: function value(e) {
          return "component <" + e.match(/in\s(\w+)/g)[0].replace(/^in\s/, "") + ">";
        }
      }]), t;
    }();

    t.default = c;
  }, function (t, n) {
    t.exports = e;
  }]);
});